// Button — design-system button with variants and a built-in loading state.
// While `loading`, the button disables and swaps its leading content for a
// spinner, preventing double-submits and giving clear feedback.

import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Spinner } from './spinner.js';

type Variant = 'primary' | 'accent' | 'ghost' | 'outline' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  loadingText?: string;
  children: ReactNode;
}

const VARIANT_CLASS: Record<Variant, string> = {
  primary: 'btn-primary',
  accent: 'btn-accent',
  ghost: 'btn-ghost',
  outline: 'btn-outline',
  danger: 'btn-danger',
};

export function Button({
  variant = 'primary',
  loading = false,
  loadingText,
  children,
  className = '',
  disabled,
  ...rest
}: ButtonProps) {
  return (
    <button
      className={`btn ${VARIANT_CLASS[variant]} ${className}`}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading && <Spinner size={14} />}
      {loading && loadingText ? loadingText : children}
    </button>
  );
}
